import { render, staticRenderFns } from "./InternalOrdersDashboard.vue?vue&type=template&id=d8f53fe2&scoped=true"
import script from "./InternalOrdersDashboard.vue?vue&type=script&lang=js"
export * from "./InternalOrdersDashboard.vue?vue&type=script&lang=js"
import style0 from "./InternalOrdersDashboard.vue?vue&type=style&index=0&id=d8f53fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f53fe2",
  null
  
)

export default component.exports